import React from 'react';
import img3 from './phone.png';

class MyComponent extends React.Component {
    handleClick = () => {
        // Replace '123456789' with your actual phone number
        window.location.href = 'tel:0545717774';
    };

    render() {
        return (
            <div className='Continar'>
                <div className='ConLine2'>
                    <img id='Me3' src={img3} alt="Phone" onClick={this.handleClick} />
                    <span id='Spa0'>اتصل بنا</span>
                </div>        </div>

        );
    }
}

export default MyComponent;
